// JS
import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import UseFetchPost from '../shared/useFetchPost';
import { randomId } from '../shared/utils';
import {
  bfAllFeed,
  bfClothingFeed,
  bfFootwearFeed,
  bfAccessoriesFeed
} from '../shared/jsonData';

// COMPONENTS
import NewArrivalsSlider from '../NewArrivalsSlider';

// COMPONENT
const NewArrivals = ({
  newArrivalsHeading = 'Black Friday Edit',
  newArrivalsSubHeading = 'Shop the latest drops',
  gaBlockName,
  gaBlockNameAll,
  gaBlockNameClothing,
  gaBlockNameFootwear,
  gaBlockNameAccessories,
  blackFriday
}) => {
  const uniqueId = randomId();

  return (
    <section
      id={'black-friday-product-grid-section-' + uniqueId}
      className="black-friday-product-grid container my-24 lg:my-32"
    >
      <Tabs
        data-name={'Black Friday'}
        data-creative={gaBlockName}
        data-id={'black-friday-' + uniqueId}
        data-position={'banner-slot-1'}
        data-type="banner"
      >
        <TabList>
          <h2 className="text-xl text-center font-semibold uppercase md:text-left">
            {newArrivalsHeading}
            {blackFriday && (
              <span className="block font-base text-md md:text-lg">
                {newArrivalsSubHeading}
              </span>
            )}
          </h2>
          <div className="flex flex-row gap-x-9 md:gap-x-14">
            <Tab>All</Tab>
            <Tab>Clothing</Tab>
            <Tab>Footwear</Tab>
            <Tab>Accessories</Tab>
          </div>
        </TabList>
        <TabPanel>
          <NewArrivalsSlider
            getProductData={UseFetchPost(
              bfAllFeed.endPointUrl,
              bfAllFeed.endPointPrams
            )}
            newArrivalsButtonLink={'/black-friday-offers/'}
            gaBlockName={gaBlockName}
          />
        </TabPanel>
        <TabPanel
          data-name={'Black Friday Clothing'}
          data-creative={gaBlockNameClothing}
          data-id={'black-friday-clothing-' + uniqueId}
          data-position={'banner-slot-2'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={UseFetchPost(
              bfClothingFeed.endPointUrl,
              bfClothingFeed.endPointPrams
            )}
            newArrivalsButtonLinkC={'/black-friday/black-friday-clothing/'}
            gaBlockName={gaBlockNameClothing}
          />
        </TabPanel>
        <TabPanel
          data-name={'Black Friday Footwear'}
          data-creative={gaBlockNameFootwear}
          data-id={'black-friday-footwear-' + uniqueId}
          data-position={'banner-slot-3'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={UseFetchPost(
              bfFootwearFeed.endPointUrl,
              bfFootwearFeed.endPointPrams
            )}
            newArrivalsButtonLinkF={'/black-friday/black-friday-footwear/'}
            gaBlockName={gaBlockNameFootwear}
          />
        </TabPanel>
        <TabPanel
          data-name={'Black Friday Accessories'}
          data-creative={gaBlockNameAccessories}
          data-id={'black-friday-accessories-' + uniqueId}
          data-position={'banner-slot-4'}
          data-type="banner"
        >
          <NewArrivalsSlider
            getProductData={UseFetchPost(
              bfAccessoriesFeed.endPointUrl,
              bfAccessoriesFeed.endPointPrams
            )}
            newArrivalsButtonLinkA={'/black-friday/black-friday-accessories/'}
            gaBlockName={gaBlockNameAccessories}
          />
        </TabPanel>
      </Tabs>
    </section>
  );
};

export default NewArrivals;
